import { render, staticRenderFns } from "./Milho2024Eua.vue?vue&type=template&id=f1559250&lang=pug"
import script from "./Milho2024Eua.vue?vue&type=script&lang=js"
export * from "./Milho2024Eua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports